import { token } from "functions/Helper";
import InActiveList from "views/Port/InActive";
import InDraft from "views/Port/InDraft";
import Published from "views/Port/Published";
import DirectionsBoatIcon from "@material-ui/icons/DirectionsBoat";
import { CreatePort } from "views/Port/Create";
import { EditPort } from "views/Port/Edit";
import { DeletePort } from "views/Port/Delete";
import { ViewPort } from "views/Port/View";
import { PublishPort } from "views/Port/Publish";
import { DeactivatePort } from "views/Port/Deactivate";

const port = () => {
  let views = [];

  if (token["master.ports.read"] === "allowed" || token.is_admin === "True") {
    views = views.concat([
      {
        path: "/Port/InDraft",
        name: "InDraft",
        mini: "ID",
        component: InDraft,
        layout: "/admin"
      },
      {
        path: "/Port/Published",
        name: "Published",
        mini: "PU",
        component: Published,
        layout: "/admin"
      },
      {
        path: "/Port/InActive",
        name: "InActive",
        mini: "IA",
        component: InActiveList,
        layout: "/admin"
      }
    ]);
  }

  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "Port",
        icon: DirectionsBoatIcon,
        state: "PortCollapse",
        views: views
      }
    ];
  return [];
};

const portHidden = () => {
  let views = [];

  if (token["master.ports.write"] === "allowed" || token.is_admin === "True") {
    views = views.concat([
      {
        path: "/Port/Create",
        name: "Create Port",
        component: CreatePort,
        layout: "/admin"
      },
      {
        path: "/Port/Edit",
        name: "Edit Port",
        component: EditPort,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      },
      {
        path: "/Port/Delete",
        name: "Delete Port",
        component: DeletePort,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      }
    ]);
  }

  if (token["master.ports.read"] === "allowed" || token.is_admin === "True") {
    views.push({
      path: "/Port/Detail",
      name: "View Port",
      component: ViewPort,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }

  if (
    token["master.ports.publish"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/Port/Publish",
      name: "View Port",
      component: PublishPort,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }

  if (
    token["master.ports.deactivate"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/Port/Deactivate",
      name: "View Port",
      component: DeactivatePort,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }

  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "Port Hidden",
        state: "portHidden",
        hideInSidebar: true,
        views: views
      }
    ];
  return [];
};

export { port, portHidden };
